// Mock data for Bezwaarmeesters clone

export const LOGO_URL = 'https://customer-assets-39nsmqrw.emergentagent.net/job_rechtshulp-portal/artifacts/2fgby0r7_logo.jpg';

export const NAVIGATION = [
  { label: 'Home', path: '/' },
  { label: 'Gratis indienen', path: '/indienen', highlight: true },
  { label: 'Werkwijze', path: '/werkwijze' },
  { label: 'Over ons', path: '/over-ons' },
  { label: 'FAQ', path: '/faq' },
  { label: 'Blogs', path: '/blog' },
];

export const USPS = [
  { title: 'Ervaren specialisten', desc: 'Ons team behandelt duizenden bezwaren per jaar en kent de procedures van binnen en van buiten.' },
  { title: 'Geen kostenrisico', desc: 'No cure, no pay. Verliezen we? Dan betaal je ons niets. 100% risicovrij.' },
  { title: 'Hoge slagingskans', desc: 'Tussen 25% en 40% van de boetes wordt verlaagd of volledig vernietigd.' },
  { title: 'Snel & persoonlijk', desc: 'Directe communicatie per e-mail met jouw persoonlijke jurist.' },
];

export const STEPS = [
  { n: 1, title: 'Upload jouw boete', desc: 'Maak een foto of upload een PDF van je boete of beschikking.' },
  { n: 2, title: 'Vul het formulier in', desc: 'Vul je gegevens in en onderteken de digitale volmacht.' },
  { n: 3, title: 'Wij nemen het over', desc: 'Onze juristen dienen het bezwaar in en houden je op de hoogte.' },
  { n: 4, title: 'Gewonnen?', desc: 'Jij ontvangt het bedrag van de boete volledig terug.' },
];

export const BOETE_TYPES = [
  { key: 'parkeerboete', title: 'Parkeerboete / Naheffingsaanslag', desc: 'Onterecht bekeurd door de scanauto of parkeercontroleur? Wij maken gratis bezwaar bij de gemeente.', bedragen: 'Gem. € 62,90 - € 82,30' },
  { key: 'cjib', title: 'CJIB-verkeersboete (Mulder)', desc: 'Te hard gereden, door rood of fout parkeren? Wij dienen bezwaar in bij de Officier van Justitie.', bedragen: 'Gem. € 40 - € 380' },
  { key: 'strafbeschikking', title: 'Strafbeschikking (vanaf € 470)', desc: 'Zwaardere overtredingen behandelen we ook, mits het bedrag boven € 470 ligt.', bedragen: 'Vanaf € 470' },
  { key: 'aanmaning', title: 'Aanmaning / dwangbevel', desc: 'Aanmaningen van gemeente of waterschap? Ook daar helpen we mee.', bedragen: 'Variabel' },
];

export const STATS = [
  { value: '~25%', label: 'Winkans per zaak' },
  { value: '1500+', label: 'Behandelde bezwaren' },
  { value: '€ 0', label: 'Kosten bij verlies' },
  { value: '4,2 / 5', label: 'Trustpilot' },
];

// Real Trustpilot reviews from https://nl.trustpilot.com/review/bezwaarmeesters.nl
export const TRUSTPILOT_REVIEWS = [
  { title: 'Gewonnen boete', text: 'De heren van bezwaarmeesters hebben mij uitstekend geholpen. Top service zeker een aanrader!', name: 'A Etnel', date: '4 december 2025', rating: 4 },
  { title: 'Bezwaar', text: 'Je wordt snel geholpen en zaken worden snel ingediend.', name: 'Barra', date: '11 november 2025', rating: 5 },
  { title: 'Goed en snel geholpen', text: 'Goed en snel geholpen', name: 'Siham', date: '13 november 2025', rating: 4 },
  { title: 'Super tevreden', text: 'Super tevreden met Bezwaarmeesters. Zij hebben mijn boete weten te laten kwijtschelden.', name: 'Noor', date: '20 september 2025', rating: 5 },
];

export const TRUSTPILOT_SCORE = { rating: 4.2, count: 187 };

export const FAQ_DATA = [
  {
    category: 'Boete indienen',
    items: [
      { q: 'Voor welke boetes kan ik bij jullie terecht?', a: 'Wij behandelen kosteloos: verkeersboetes (letter M rechtsboven), ingevorderde rijbewijzen, parkeerboetes/naheffingsaanslagen, strafbeschikkingen vanaf € 470 en aanmaningen/dwangbevelen van gemeenten of waterschappen.' },
      { q: 'Hoe groot is de kans dat ik mijn zaak win?', a: 'Uit onze ervaring: 25% van de boetes wordt volledig kwijtgescholden en 40% wordt (flink) verlaagd. Je kans op een positief resultaat ligt tussen 25% en 40%.' },
      { q: 'Moet ik mijn post ook naar jullie sturen?', a: 'Maak een duidelijke foto van de ontvangen post en stuur deze naar info@bezwaarmeesters.nl samen met je zaaknummer. Zo verwerken wij de informatie direct.' },
      { q: 'Voor welke boetes kan ik niet bij jullie terecht?', a: 'Boetes met een (T) in de rechterbovenhoek zijn transactievoorstellen. Deze vallen niet onder onze dienstverlening. Schakel dan een beëdigd advocaat in.' },
    ],
  },
  {
    category: 'Geldzaken',
    items: [
      { q: 'Hoe zijn jullie diensten gratis?', a: 'De wet bepaalt dat wanneer een boete onterecht is opgelegd, de overheid onze kosten vergoedt. Winnen wij, dan betaalt de overheid. Verliezen wij, dan kost het jou niets.' },
      { q: 'Moet ik mijn boete meteen betalen?', a: 'Ja, betaal direct om verhogingen te voorkomen. Winnen wij, dan krijg je het bedrag terug op je rekening.' },
      { q: 'Wat betekent “zekerheid stellen”?', a: 'Je betaalt de boete inclusief administratiekosten (zonder verhogingen). Betaal altijd op tijd - te laat kan leiden tot afwijzing.' },
    ],
  },
  {
    category: 'Parkeerboete (naheffingsaanslag)',
    items: [
      { q: 'Wat is een naheffingsaanslag?', a: 'Een parkeerboete van de gemeente omdat er te weinig parkeergeld is betaald. Herkenbaar aan het woord “naheffingsaanslag”. Betaaltermijnen verschillen per gemeente (Amsterdam 2 weken, elders vaak 6 weken).' },
      { q: 'Waarom bezwaar maken?', a: 'Regelmatig fouten: scanauto leest kenteken verkeerd, verkeerde kenteken bij parkeeractie ingevoerd, of betaald in verkeerde zone.' },
      { q: 'Hoe verloopt de procedure?', a: 'Je hebt 6 weken bezwaartermijn. Wij dienen namens jou in. Gemiddeld 10 weken voor de uitspraak.' },
    ],
  },
  {
    category: 'CJIB-boetes',
    items: [
      { q: 'Wat is een Mulderboete?', a: 'Een boete voor een lichte verkeersovertreding onder de Wet Mulder (WAHV). Administratief afgehandeld door het CJIB.' },
      { q: 'Wanneer moet ik betalen?', a: 'Tijdens bezwaar blijf je verplicht te betalen. Wordt het toegewezen, dan krijg je het teruggestort.' },
      { q: 'Hoe verloopt de bezwaarprocedure?', a: 'Stap 1: bezwaar bij OvJ (binnen 6 weken). Stap 2: beroep bij kantonrechter. Stap 3: hoger beroep bij Gerechtshof Arnhem-Leeuwarden. Totaal kan tot 2 jaar duren.' },
    ],
  },
];

export const BLOG_POSTS = [
  {
    slug: 'parkeerboete-amsterdam-bezwaar-maken',
    title: 'Parkeerboete Amsterdam: zo maak je binnen 2 weken bezwaar',
    excerpt: 'De gemeente Amsterdam hanteert een korte bezwaartermijn van 14 dagen. Ontdek hoe je een naheffingsaanslag succesvol aanvecht.',
    date: '10 juli 2025',
    author: 'mr. Eva Bakker',
    category: 'Parkeerboete',
    image: 'https://images.unsplash.com/photo-1613314188851-2c04697535ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    readTime: '11 min',
  },
  {
    slug: 'cjib-termijnen-uitleg',
    title: 'CJIB-termijnen uitgelegd: wanneer moet je bezwaar maken?',
    excerpt: 'Alles over dagtekening, betaaltermijn en de 6-weken bezwaartermijn bij CJIB-boetes.',
    date: '3 juli 2025',
    author: 'mr. Thijs Meijer',
    category: 'CJIB',
    image: 'https://images.unsplash.com/photo-1714658950443-883a30414223?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    readTime: '10 min',
  },
  {
    slug: 'flitspaal-onterecht-geflitst',
    title: 'Onterecht geflitst? 5 succesvolle bezwaargronden',
    excerpt: 'Van kalibratiefouten tot bewegwijzering - dit zijn de meest kansrijke argumenten tegen een flitsboete.',
    date: '28 juni 2025',
    author: 'mr. Eva Bakker',
    category: 'Snelheidsboete',
    image: 'https://images.unsplash.com/photo-1605546290557-ff57ffe5abcc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    readTime: '11 min',
  },
  {
    slug: 'scanauto-kentekenfout',
    title: 'Scanauto leest kenteken verkeerd: wat nu?',
    excerpt: 'Steeds meer gemeenten gebruiken scanautos. Wat als jouw kenteken onterecht is gelezen?',
    date: '20 juni 2025',
    author: 'mr. Lars Hendriks',
    category: 'Parkeerboete',
    image: 'https://images.unsplash.com/photo-1605374780828-82eb7ecf7cf7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    readTime: '8 min',
  },
  {
    slug: 'door-rood-rijden-bezwaar',
    title: 'Door rood gereden? Zo maak je succesvol bezwaar',
    excerpt: '€ 310 boete voor door rood rijden is fors. Ontdek wanneer bezwaar zin heeft.',
    date: '15 juni 2025',
    author: 'mr. Thijs Meijer',
    category: 'CJIB',
    image: 'https://images.unsplash.com/photo-1607857519715-9e94e187f5a8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    readTime: '10 min',
  },
  {
    slug: 'strafbeschikking-470-euro',
    title: 'Strafbeschikking van € 470 of hoger: je rechten',
    excerpt: 'Alles wat je moet weten over verzet aantekenen tegen een strafbeschikking.',
    date: '5 juni 2025',
    author: 'mr. Lars Hendriks',
    category: 'Strafbeschikking',
    image: 'https://images.unsplash.com/photo-1589994965851-a8f479c573a9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    readTime: '11 min',
  },
];

export const BLOG_CONTENT = {
  'parkeerboete-amsterdam-bezwaar-maken': `De gemeente Amsterdam is bekend om haar strenge parkeerbeleid en de scherpe controle door scanauto's en handhavers. Wat veel Amsterdammers en bezoekers echter niet weten, is dat de gemeente een van de weinige gemeenten in Nederland is die een bezwaartermijn van slechts **14 dagen** hanteert voor naheffingsaanslagen parkeerbelasting. Dat is dus twee keer zo kort als de wettelijke standaard van 6 weken die je bij CJIB-boetes hebt. In dit uitgebreide artikel leggen wij uit hoe je binnen die krappe termijn toch een sterk bezwaar opbouwt, welke gronden kansrijk zijn en welke veelgemaakte fouten je moet voorkomen.

## Waarom Amsterdam een uitzondering is
De parkeerbelasting valt onder de Gemeentewet (artikel 225). Gemeenten mogen zelf de invulling van de bezwaarprocedure bepalen, mits deze binnen de kaders van de Algemene wet bestuursrecht (Awb) blijft. De hoofdregel is dat je 6 weken de tijd hebt om bezwaar te maken vanaf de dagtekening van het besluit. Amsterdam heeft echter, net als een klein aantal andere grote gemeenten, gekozen voor een verkorte termijn omdat de gemeente jaarlijks honderdduizenden naheffingen uitschrijft en de doorlooptijden wil beperken.

Belangrijk om te weten: die 14 dagen beginnen te lopen vanaf de dagtekening op de brief, niet vanaf het moment dat jij de brief in je brievenbus vond. Ben je op vakantie geweest? Dan kan het gebeuren dat de termijn al bijna verstreken is voordat je de brief openmaakt. Neem in dat geval direct contact op met Bezwaarmeesters.nl - wij dienen desnoods een pro forma bezwaar in binnen de termijn en vullen de motivering later aan.

## Meest voorkomende oorzaken van onterechte naheffingsaanslagen

### 1. Scanauto-fouten
Amsterdam kent inmiddels tientallen scanauto's die dagelijks door de stad rijden en kentekens uitlezen met behulp van OCR (Optical Character Recognition). Deze technologie is verre van feilloos. Een 8 kan gelezen worden als een B, een 0 als een O, een 5 als een S en omgekeerd. Zelfs één karakter verschil is genoeg voor een onterechte naheffing van gemiddeld € 82,30.

### 2. Zonevergissingen
Amsterdam kent tientallen tariefgebieden. Wie in zone A parkeert maar per ongeluk zone B intoetst in de parkeerapp, betaalt weliswaar - maar niet voor het juiste gebied. De scanauto herkent dit als "niet betaald" en schrijft een naheffing uit. Bezwaar is dan kansrijk, mits je kunt aantonen dat je binnen tien minuten na de scan de betaling hebt gecorrigeerd of dat de zone-borden onduidelijk waren.

### 3. Verkeerd kenteken bij parkeeractie
Klassieker: bij de start van je parkeeractie tik je één cijfer verkeerd in. De scanauto vindt geen match en boekt een boete. Ook hier is bezwaar mogelijk zolang je kunt aantonen dat je wel betaald hebt (bijvoorbeeld met een screenshot van de parkeerapp).

### 4. Betaling te laat verwerkt door 4G-storing
In gebieden met slechte mobiele dekking (parkeergarages, ondergrondse plekken) kan de betaling met vertraging bij de gemeente aankomen. Als de scanauto in die tussenperiode langsrijdt, ontvang je een naheffing terwijl je gewoon hebt betaald.

### 5. Defect aan de parkeerautomaat
Bij een defecte automaat ben je niet in overtreding. Meld direct 14020 en maak een foto van de automaat. Deze foto is later goud waard bij het bezwaar.

## Zo maak je binnen 14 dagen sterk bezwaar
1. **Verzamel bewijs**: screenshot uit de parkeerapp, bankafschrift, foto van de automaat of van je auto ter plaatse.
2. **Noteer de dagtekening**: staat rechtsboven op de brief.
3. **Meld je aan bij Bezwaarmeesters.nl**: wij nemen de deadline over en dienen bezwaar in bij de heffingsambtenaar.
4. **Betaal de boete tijdig**: dit heet "zekerheid stellen". Winnen wij, dan krijg je het geld terug op je rekening.

## Wat gebeurt er na je bezwaar?
De gemeente Amsterdam heeft na ontvangst van je bezwaarschrift maximaal 12 weken (kan verlengd worden met 6 weken) om een beslissing te nemen. Duurt het langer? Dan kunnen wij een dwangsom eisen wegens niet-tijdig beslissen. Wordt je bezwaar toegewezen, dan wordt de naheffing vernietigd en krijg je het bedrag terug.

## Waarom via Bezwaarmeesters.nl?
Wij hebben jarenlange ervaring met de Amsterdamse bezwaarprocedure, kennen de heffingsambtenaren en weten precies welke argumenten kansrijk zijn. Bovendien werken wij op basis van no cure, no pay - verliezen we, dan kost het jou niets.`,

  'cjib-termijnen-uitleg': `Bij een CJIB-boete (Centraal Justitieel Incassobureau) draait alles om de **dagtekening**. Dat is de datum die rechtsboven op de brief staat en niet per se de datum dat je de brief in je bus vond. Vanaf die dagtekening loopt de wettelijke bezwaartermijn van 6 weken volgens de Wet administratiefrechtelijke handhaving verkeersvoorschriften (Wahv, ook wel Wet Mulder genoemd). In dit artikel leggen wij alle termijnen uit die relevant zijn voor jouw CJIB-boete en waarom het cruciaal is om deze goed te bewaken.

## De belangrijkste termijnen op een rij

### Betaaltermijn: 8 weken
Vanaf de dagtekening heb je 8 weken de tijd om te betalen. Betaal je niet op tijd? Dan volgt er een aanmaning en een verhoging.

### Bezwaartermijn: 6 weken
Binnen deze 6 weken moet je bezwaar (in Wahv-termen: "beroep") hebben ingediend bij de Officier van Justitie. Overschrijd je deze termijn, dan wordt je bezwaar niet-ontvankelijk verklaard, ongeacht hoe sterk je zaak is.

### 1e verhoging: na 8 weken (+ 50%)
Ben je nog steeds niet betaald, dan verhoogt het CJIB de boete met 50%. Een boete van € 240 wordt dan € 360.

### 2e verhoging: na 16 weken (+ 100%)
Nog niet betaald? Dan komt er nog eens een verhoging bij, tot uiteindelijk het dubbele van het oorspronkelijke bedrag. Een boete van € 240 wordt uiteindelijk € 480.

### Dwangbevel en verhaal
Na de 2e verhoging kan het CJIB overgaan tot dwanginvordering: beslag op je loon, uitkering of bankrekening. Ook inname van je rijbewijs of gijzeling (max 7 dagen) behoort tot de mogelijkheden.

## Wat als de dagtekening al lang geleden is?
Soms zit er een discrepantie tussen dagtekening en bezorging. Bezwaarmeesters.nl kan in uitzonderlijke gevallen argumenteren dat de termijn pas begon te lopen bij ontvangst, zeker als er sprake was van adreswijziging, vakantie of ziekte. Dit is een juridisch subtiel punt waar wij ervaring mee hebben.

## Waarom altijd op tijd betalen tijdens bezwaar?
Ook als je bezwaar maakt, ben je verplicht om de boete op tijd te betalen (het "stellen van zekerheid"). Doe je dat niet, dan wordt je beroep niet-ontvankelijk verklaard door de kantonrechter. Winnen wij, dan krijg je het bedrag volledig terug van het CJIB, meestal binnen 4 tot 6 weken na de uitspraak.

## De volledige beroepsketen
1. **Beroep bij Officier van Justitie (OvJ)**: binnen 6 weken vanaf dagtekening.
2. **Beroep bij kantonrechter**: binnen 6 weken vanaf de uitspraak OvJ.
3. **Hoger beroep bij Gerechtshof Arnhem-Leeuwarden**: binnen 6 weken, mits het boetebedrag boven € 70 ligt.

Het hele proces kan tot 2 jaar duren, maar het is de moeite waard: bij winst krijg je niet alleen de boete terug, maar ook een proceskostenvergoeding van de overheid - die vergoeding is precies waarmee wij ons werk bekostigen.

## Tips van onze juristen
- Bewaar de originele envelop met poststempel - dit kan bewijs zijn voor de daadwerkelijke bezorgdatum.
- Reageer nooit op telefonische aanmaningen zonder eerst juridisch advies te vragen.
- Betaal via automatische incasso om verhogingen te voorkomen tijdens de procedure.`,

  'flitspaal-onterecht-geflitst': `Een flitsboete lijkt vaak onaantastbaar: een foto met kenteken, een gemeten snelheid en een keurige feitcode. Toch zijn er meerdere juridische en technische gronden om succesvol bezwaar te maken tegen een snelheidsboete. In dit uitgebreide artikel bespreken wij vijf van de meest kansrijke bezwaargronden, plus praktische tips van onze specialisten verkeersrecht.

## 1. Kalibratiefout van de flitsapparatuur
Iedere radar-, laser- of trajectcontrole-installatie in Nederland moet jaarlijks worden geijkt door het NMi (Nederlands Meetinstituut) of een geaccrediteerde instantie. Deze kalibratie waarborgt dat de meting binnen een tolerantiebereik van 3% valt. Ontbreekt het kalibratiecertificaat, of is deze verlopen ten tijde van de meting, dan is de gemeten snelheid juridisch onbetrouwbaar.

Wij kunnen als gemachtigden inzage vragen in het kalibratiecertificaat. In sommige gevallen blijkt dat de kalibratie is uitgevoerd na de datum van jouw boete of dat er onduidelijkheden zijn over de onderhoudsintervallen. In beide gevallen is er goede kans op vernietiging.

## 2. Onduidelijke of onterechte bewegwijzering
De maximumsnelheid moet duidelijk aangegeven zijn. Volgens vaste jurisprudentie moet een bord:
- Zichtbaar zijn (niet verscholen achter begroeiing of een vrachtwagen);
- In redelijke afstand voor het punt van meting geplaatst zijn;
- Consistent zijn met de verkeerssituatie (bijv. 30 km/u in een 50-gebied kan alleen bij duidelijke wegversmalling).

Wij hebben zaken gewonnen waar het snelheidsbord was omgewaaid door storm, waar bomen het bord versperden, of waar het bord slechts één meter voor de flitspaal stond - wat volgens de jurisprudentie onvoldoende reactietijd geeft.

## 3. Verkeerde chauffeur (leaseauto of zakenauto)
Bij lease- of zakenauto's staat het kenteken op naam van de leasemaatschappij of werkgever. De boete komt in eerste instantie bij hen terecht. In veel gevallen wordt deze automatisch doorgeboekt naar de daadwerkelijke bestuurder - maar niet altijd correct.

Wij regelen de tenaamstelling. Dit betekent dat de boete formeel op naam van de bestuurder wordt gezet, of - in geval van meerdere gebruikers - dat de bezwaarprocedure wordt gevoerd namens de rechthebbende.

## 4. Meetfout door schaduw, lichtinval of andere voertuigen
Bij radar- en lasermetingen kan onder specifieke omstandigheden een verkeerd voertuig gemeten worden. Denk aan:
- Een vrachtwagen die vlak voor jou reed en de meting verstoorde;
- Reflectie van zonlicht op een raam of natte weg;
- Twee auto's zeer dicht op elkaar, waarbij de meting aan de verkeerde wordt toegewezen.

Deze bezwaren zijn technisch complex maar wel kansrijk als wij inzage krijgen in de meetgegevens en de fotoserie.

## 5. Termijnoverschrijding door de Officier van Justitie
De OvJ moet binnen 32 weken (uitzonderlijk max 52 weken) beslissen op jouw beroep. Doet zij dat niet, dan kunnen wij een dwangsom eisen wegens niet-tijdig beslissen. Deze dwangsom kan oplopen tot € 1.442 per zaak.

## Praktische tips
- **Bewaar dashcam-beelden**: goud waard bij twijfel over snelheid of situatie.
- **Vraag de flitsfoto op**: dat kan gratis bij het CJIB en geeft cruciaal bewijs.
- **Noteer weersomstandigheden**: zware regen of mist beïnvloedt de meting.
- **Meld direct via ons formulier**: wij hebben 6 weken vanaf dagtekening, dus wacht niet.

Wij behandelen jouw zaak op no cure, no pay-basis. Verliezen we, dan kost het jou niets.`,

  'scanauto-kentekenfout': `Sinds 2019 gebruiken steeds meer gemeenten scanauto's: rijdende voertuigen met camera's die kentekens uitlezen en direct koppelen aan een parkeerdatabase. Amsterdam, Rotterdam, Utrecht, Den Haag, Eindhoven en Groningen zijn koplopers. Het systeem is efficiënt maar allesbehalve feilloos. In dit artikel duiken wij in de techniek, laten wij zien welke fouten voorkomen en wat je kunt doen als jij onterecht wordt bekeurd.

## Hoe werkt een scanauto?
Een scanauto rijdt op een routine-route door de stad. Op het dak zit een ANPR-systeem (Automatic Number Plate Recognition) met meerdere hogeresolutiecamera's. Deze registreren de kentekens van geparkeerde auto's en vergelijken die real-time met de database van betaalde parkeeracties. Vindt de scanauto geen match, dan wordt een naheffing uitgeschreven - vaak zonder tussenkomst van een menselijke handhaver.

## De foutmarge in cijfers
Uit onafhankelijk onderzoek en onze eigen praktijk blijkt dat ANPR-systemen een leesfout hebben van gemiddeld **3 tot 5%**. Bij een gemiddelde gemeente die 500.000 kentekens per jaar scant, betekent dat tussen de 15.000 en 25.000 potentieel onterechte boetes per jaar. Meestal betreft het:

- **Karakterverwisselingen**: 0/O, 1/I, 5/S, 8/B - vooral bij vieze of verweerde kentekenplaten.
- **Deels afgeplakte platen**: sneeuw, modder of een fietsdrager kan één cijfer verbergen.
- **Andere landen kentekens**: buitenlandse kentekens worden vaak niet herkend of foutief geïnterpreteerd.
- **Nieuwe of tijdelijke kentekens**: proefkentekens en handelaarskentekens geven vaak issues.

## Wat te doen bij een scanfout?
**Stap 1: verzamel bewijs**  
Maak direct (indien mogelijk) een foto van je auto op de locatie van de vermeende overtreding. Zorg dat de kentekenplaat en de omgeving duidelijk zichtbaar zijn.

**Stap 2: check de scanfoto**  
Op de naheffing staat vaak een verwijzing naar het beschikkingsnummer. Bij ons ingediende zaken vragen wij de originele scanfoto op bij de gemeente. Zo kunnen wij zwart op wit aantonen dat het geregistreerde kenteken afwijkt van jouw daadwerkelijke kenteken.

**Stap 3: dien bezwaar in**  
Via Bezwaarmeesters.nl. Wij hebben directe lijnen met de heffingsambtenaren van alle grote gemeenten en weten binnen enkele werkdagen of de scan technisch verifieerbaar is.

## Andere veelvoorkomende scanfouten
- **Verkeerde tijdstempel**: scanauto boekt jou 5 minuten voor je parkeeractie begon.
- **Zonefout**: auto stond op de grens van twee tariefzones, scanauto koos verkeerde.
- **Dubbel gescand**: sommige gemeenten sturen per abuis twee identieke naheffingen.

## Wat als je bezwaar wordt afgewezen?
Dan kunnen wij binnen 6 weken beroep aantekenen bij de rechtbank sector belastingrecht. Ook daar behandelen wij de zaak kosteloos. Winnen wij, dan krijg je proceskostenvergoeding.

## Voorkomen is beter
- Houd je kenteken schoon (vooral in de winter).
- Bevestig een fietsdrager altijd zo dat het kenteken zichtbaar blijft, of gebruik een aanvullende kentekenplaat.
- Controleer bij de start van je parkeeractie of het juiste kenteken is ingevoerd in de app.`,

  'door-rood-rijden-bezwaar': `Door rood rijden kost € 310 volgens de meest voorkomende feitcode R601. Voor veel automobilisten is dit een van de duurste boetes die zij ooit ontvangen, en tegelijk een van de meest emotioneel geladen: de suggestie dat je bewust een verkeerslicht negeert, staat haaks op hoe de meesten van ons zichzelf zien in het verkeer. De politie geeft zelden coulance, maar toch is bezwaar in bepaalde gevallen zeer kansrijk. In dit artikel bespreken wij wanneer bezwaar zin heeft, welk bewijs cruciaal is en welke argumenten wij succesvol hebben gebruikt bij het gerechtshof.

## Hoe werkt roodlichtdetectie?
Op kruispunten met een roodlichtcamera staat een sensor in het wegdek, meestal een inductielus, direct achter de stopstreep. Passeert een voertuig deze lus terwijl het licht rood is, dan worden twee foto's gemaakt: één van je auto over de streep en één van je auto in het kruispunt. De tijd tussen beide foto's, gecombineerd met de tijd dat het licht al rood stond, bepaalt of het een overtreding is.

## Wanneer heeft bezwaar zin?

### 1. Oranje-rood-grens
Volgens de Regeling Verkeerslichten mag je op oranje doorrijden mits stoppen niet meer veilig mogelijk is. Rijd je met 50 km/u en het licht springt op 30 meter afstand op oranje, dan is stoppen bij nat wegdek juridisch niet meer haalbaar. De rechter erkent dit in vaste jurisprudentie.

Wij vragen bij het CJIB de complete foto-serie op, inclusief de tijdstempels. Vaak blijkt dat het licht slechts 0,1 tot 0,3 seconden op rood stond ten tijde van passage - een moment waar juridisch discussie over mogelijk is.

### 2. Voorrangssituatie voor hulpverleningsvoertuig
Rijd je door rood omdat een ambulance of politievoertuig met sirenes achter je zit? Dan is doorrijden zelfs verplicht (art. 91 RVV 1990: je moet doorgaande voertuigen doorlaten). Bewijs met dashcam-beelden of een verklaring van de hulpverleningsdienst is dan doorslaggevend.

### 3. Defect of onduidelijk verkeerslicht
Een verkeerslicht dat abrupt van groen naar rood springt zonder oranje-fase is defect. Ook een licht dat halfzichtbaar is (door zonlicht, sneeuw of graffiti) telt niet als "voldoende bekendgemaakt".

### 4. Meetfout of foutieve identificatie
Bij drukke kruispunten kan de camera de verkeerde auto vastleggen. Vooral bij bussen of vrachtwagens die vlak voor jou passeren, kan de sensor jou onterecht als overtreder aanwijzen.

### 5. Feitcode-verwisseling
Sommige boetes worden onder een verkeerde feitcode uitgeschreven (bijv. R601 in plaats van de lichtere R608 voor "gedeeltelijk door rood"). Bezwaar op de feitcode is soms kansrijker dan bezwaar op de overtreding zelf.

## Bewijs is alles
- **Dashcam**: cruciaal. Wij adviseren iedere Bezwaarmeesters-cliënt om een dashcam te installeren.
- **Flitsfoto opvragen**: gratis bij het CJIB, en cruciaal voor onze analyse.
- **Getuigenverklaring**: passagier of andere weggebruiker kan verklaring afleggen.
- **Weerbericht van die dag**: KNMI-data over regen of zicht kan onderbouwing zijn.

## Wat wij doen bij Bezwaarmeesters.nl
Wij bekijken elke roodlichtboete individueel. Zien wij geen kansrijke bezwaargrond, dan zeggen wij dat eerlijk. Zijn er wel aanknopingspunten, dan starten wij de bezwaarprocedure op basis van no cure, no pay. Winnen wij, dan krijg je € 310 terug op je rekening.`,

  'strafbeschikking-470-euro': `Een strafbeschikking is géén gewone verkeersboete: het is een strafrechtelijke sanctie opgelegd door het Openbaar Ministerie (OM), zonder tussenkomst van een rechter. Deze relatief nieuwe procedure (Wet OM-afdoening, 2008) betekent dat een officier van justitie zelf kan besluiten om een boete, taakstraf of ontzegging van de rijbevoegdheid op te leggen. Zwaardere overtredingen, waaronder rijden onder invloed, roekeloos rijgedrag en snelheidsovertredingen boven de 30 km/u, worden vaak via een strafbeschikking afgedaan. Vanaf een bedrag van € 470 wordt de zaak juridisch complex en dan behandelen wij deze kosteloos voor je.

## Verschil met een gewone (Wahv-)boete
Een Wahv-boete is administratief: geen strafblad, en de bezwaarprocedure loopt via de OvJ en kantonrechter. Een strafbeschikking daarentegen:
- **Geeft een strafblad** bij een boete boven € 100 (justitiële documentatie);
- **Wordt vastgelegd in het justitieel documentatiesysteem** en is zichtbaar voor werkgevers die een VOG-aanvraag doen;
- **Kan worden aangevochten via "verzet"** - een fundamenteel ander rechtsmiddel dan bezwaar.

## Verzet aantekenen: binnen 14 dagen
Anders dan de gebruikelijke 6-weken termijn van Wahv-boetes, geldt bij strafbeschikkingen een termijn van **14 dagen** om verzet aan te tekenen. Doe je dat niet, dan wordt de strafbeschikking automatisch onherroepelijk en komt op je strafblad.

Het verzet dient schriftelijk te worden ingediend bij het OM (Parket CVOM). Vervolgens komt de zaak in behandeling bij de kantonrechter of politierechter, afhankelijk van de zwaarte van de sanctie.

## Waarom bezwaar zin heeft
Uit CBS-cijfers blijkt dat ongeveer **30% van de strafbeschikkingen** wordt gewijzigd of geheel ingetrokken na verzet. Redenen daarvoor zijn:

1. **Onjuiste feiten of onvolledige onderbouwing**: het OM kan snel werken maar mist soms nuances.
2. **Verzachtende omstandigheden** die niet zijn meegewogen (medische situatie, noodgeval).
3. **Meetfouten** bij alcohol- of snelheidsmetingen.
4. **Formele gebreken** in de beschikking zelf.

## Onze aanpak
Bij Bezwaarmeesters.nl:
1. Nemen wij de beschikking door en identificeren juridische gebreken.
2. Verzenden wij het formele verzet binnen de wettelijke termijn.
3. Bereiden wij de zitting bij de kantonrechter voor.
4. Vertegenwoordigen wij jou desgewenst op zitting.

## Combinatie met alcohol- of drugscontrole
Vaak worden strafbeschikkingen boven de € 470 gecombineerd met een alcoholmeting of drugscontrole. Deze metingen zijn vatbaar voor verweer:
- Blaastest binnen 20 minuten na roken of drinken is technisch onbetrouwbaar.
- Ademanalyse-apparaten moeten gekalibreerd en gecertificeerd zijn.
- Bloedafname moet plaatsvinden door een bevoegd arts binnen het juiste tijdvak.

## Waarom vanaf € 470?
Onder de € 470 is de proceskostenvergoeding die de overheid uitkeert bij winst te laag om onze werkwijze economisch verantwoord te maken. Vanaf € 470 (waar wij zelfs bij winst substantiële vergoeding krijgen) kunnen wij no cure, no pay hanteren.

## Geen risico voor jou
Ondanks de complexiteit werken wij ook hier op basis van no cure, no pay. Winnen wij het verzet, dan krijg je de gehele boete terug en blijft je strafblad schoon. Verliezen wij, dan betaal je ons niets - je bent alleen de oorspronkelijke boete kwijt, zoals bij elke andere procedure.`,
};

export const MOCK_SUBMISSIONS = [
  { id: 'BZW-2025-00123', datum: '12-07-2025', type: 'Parkeerboete', instantie: 'Gemeente Amsterdam', bedrag: 82.30, status: 'Ontvangen', deadline: '26-07-2025', kenteken: '12-ABC-3', beschikkingsnummer: 'AMS20250712-8842' },
  { id: 'BZW-2025-00089', datum: '28-06-2025', type: 'CJIB-verkeersboete', instantie: 'CJIB', bedrag: 240.00, status: 'In behandeling', deadline: '09-08-2025', kenteken: '45-XYZ-9', beschikkingsnummer: '4059-8710-9931' },
  { id: 'BZW-2025-00042', datum: '15-05-2025', type: 'Naheffingsaanslag', instantie: 'Gemeente Rotterdam', bedrag: 76.50, status: 'Ingediend', deadline: '26-06-2025', kenteken: '89-DEF-2', beschikkingsnummer: 'RDM20250515-1122' },
  { id: 'BZW-2025-00007', datum: '02-04-2025', type: 'CJIB-verkeersboete', instantie: 'CJIB', bedrag: 310.00, status: 'Gewonnen', deadline: '14-05-2025', kenteken: '77-KLM-5', beschikkingsnummer: '4061-2384-0102' },
];

export const ADMIN_SUBMISSIONS = [
  { id: 'BZW-2025-00123', klant: 'Karim el Amrani', email: 'karim@example.nl', datum: '12-07-2025', type: 'Parkeerboete', instantie: 'Gemeente Amsterdam', bedrag: 82.30, status: 'Ontvangen', deadline: '26-07-2025', jurist: 'mr. Eva Bakker' },
  { id: 'BZW-2025-00122', klant: 'Sanne de Vries', email: 'sanne.dv@example.nl', datum: '11-07-2025', type: 'CJIB-verkeersboete', instantie: 'CJIB', bedrag: 240.00, status: 'In behandeling', deadline: '22-08-2025', jurist: 'mr. Thijs Meijer' },
  { id: 'BZW-2025-00121', klant: 'Peter Janssen', email: 'p.janssen@example.nl', datum: '10-07-2025', type: 'Naheffingsaanslag', instantie: 'Gemeente Utrecht', bedrag: 65.00, status: 'Ingediend', deadline: '21-08-2025', jurist: 'mr. Lars Hendriks' },
  { id: 'BZW-2025-00120', klant: 'Fleur van der Berg', email: 'fleur.vdb@example.nl', datum: '09-07-2025', type: 'Strafbeschikking', instantie: 'OM', bedrag: 550.00, status: 'Beslissing', deadline: '20-08-2025', jurist: 'mr. Eva Bakker' },
  { id: 'BZW-2025-00119', klant: 'Mo Yildiz', email: 'mo.y@example.nl', datum: '08-07-2025', type: 'Parkeerboete', instantie: 'Gemeente Den Haag', bedrag: 72.90, status: 'Gewonnen', deadline: '19-08-2025', jurist: 'mr. Thijs Meijer' },
];

export const STATUS_COLORS = {
  'Ontvangen': 'bg-blue-100 text-blue-800 border-blue-200',
  'In behandeling': 'bg-amber-100 text-amber-800 border-amber-200',
  'Ingediend': 'bg-indigo-100 text-indigo-800 border-indigo-200',
  'Beslissing': 'bg-purple-100 text-purple-800 border-purple-200',
  'Gewonnen': 'bg-emerald-100 text-emerald-800 border-emerald-200',
  'Afgewezen': 'bg-rose-100 text-rose-800 border-rose-200',
};

// Mock backend document parsing result - in real backend this comes from Gemini Vision.
// Structure matches all fields the customer wants:
// NAW gegevens, beschikkingsnummer, datum beschikking, omschrijving overtreding,
// tijdstip van vermeende gedraging, kenteken, uiterlijke datum bezwaar/beroep.
export const mockOcrExtract = (filename = 'boete.pdf') => {
  const today = new Date();
  const iso = (d) => d.toISOString().slice(0, 10);
  const dt = (d) => d.toISOString().slice(0, 16).replace('T', ' ');
  // Generate a "beschikking" dated ~14 days ago so bezwaartermijn (6wk = 42d) still has ~28 days left
  const beschikkingDatum = new Date(today.getTime() - 14 * 24 * 60 * 60 * 1000);
  const gedragingDatum = new Date(beschikkingDatum.getTime() - 7 * 24 * 60 * 60 * 1000);
  const uiterlijkDatum = new Date(beschikkingDatum.getTime() + 42 * 24 * 60 * 60 * 1000);
  const uiterlijkKort = new Date(beschikkingDatum.getTime() + 14 * 24 * 60 * 60 * 1000);

  const templates = [
    {
      naam_geadresseerde: 'De heer J. de Vries',
      straat_geadresseerde: 'Prinsengracht 263',
      postcode_geadresseerde: '1016 GV',
      woonplaats_geadresseerde: 'Amsterdam',
      beschikkingsnummer: '4059-8710-9931',
      datum_beschikking: iso(beschikkingDatum),
      omschrijving_overtreding: 'Overschrijding van de maximumsnelheid op autosnelweg met 15 km/u',
      tijdstip_gedraging: dt(gedragingDatum),
      locatie_gedraging: 'A2 hectometerpaal 42,3 richting Utrecht',
      kenteken: '45-XYZ-9',
      voertuigsoort: 'Personenauto',
      bedrag: 240.00,
      instantie: 'Centraal Justitieel Incassobureau (CJIB)',
      type: 'CJIB-verkeersboete (Mulder)',
      uiterlijke_datum_bezwaar: iso(uiterlijkDatum),
    },
    {
      naam_geadresseerde: 'Mevr. S. Bakker',
      straat_geadresseerde: 'Damrak 70',
      postcode_geadresseerde: '1012 LM',
      woonplaats_geadresseerde: 'Amsterdam',
      beschikkingsnummer: 'AMS20250712-8842',
      datum_beschikking: iso(beschikkingDatum),
      omschrijving_overtreding: 'Parkeren zonder geldig parkeerbewijs (art. 225 Gemeentewet)',
      tijdstip_gedraging: dt(gedragingDatum),
      locatie_gedraging: 'Nieuwendijk 42, Amsterdam - zone A1',
      kenteken: '12-ABC-3',
      voertuigsoort: 'Personenauto',
      bedrag: 82.30,
      instantie: 'Gemeente Amsterdam',
      type: 'Naheffingsaanslag parkeerbelasting',
      uiterlijke_datum_bezwaar: iso(uiterlijkKort), // Amsterdam: kortere termijn
    },
    {
      naam_geadresseerde: 'De heer T. Meijer',
      straat_geadresseerde: 'Coolsingel 40',
      postcode_geadresseerde: '3011 AD',
      woonplaats_geadresseerde: 'Rotterdam',
      beschikkingsnummer: '4061-2384-0102',
      datum_beschikking: iso(beschikkingDatum),
      omschrijving_overtreding: 'Door rood licht rijden (feitcode R601)',
      tijdstip_gedraging: dt(gedragingDatum),
      locatie_gedraging: 'Erasmusbrug richting centrum',
      kenteken: '77-KLM-5',
      voertuigsoort: 'Personenauto',
      bedrag: 310.00,
      instantie: 'Centraal Justitieel Incassobureau (CJIB)',
      type: 'CJIB-verkeersboete (Mulder)',
      uiterlijke_datum_bezwaar: iso(uiterlijkDatum),
    },
  ];
  return templates[Math.floor(Math.random() * templates.length)];
};
